import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import o from "classnames";
import q from "../../helpers/nanoid.js";
import j from "../../icons/Checkmark.js";
const y = "forma-ui__checkbox__checkbox", F = "forma-ui__checkbox__container", R = "forma-ui__checkbox__hidden", T = "forma-ui__checkbox__disabled", v = "forma-ui__checkbox__fullWidth", w = "forma-ui__checkbox__inputContainer", z = "forma-ui__checkbox__label", A = "forma-ui__checkbox__icon", B = "forma-ui__checkbox__square", D = "forma-ui__checkbox__checked", E = "forma-ui__checkbox__small", G = "forma-ui__checkbox__medium", c = {
  checkbox: y,
  container: F,
  hidden: R,
  disabled: T,
  fullWidth: v,
  inputContainer: w,
  label: z,
  icon: A,
  square: B,
  checked: D,
  small: E,
  medium: G
}, P = W(({
  id: a = q(8),
  name: H,
  onChange: t = () => {
  },
  hidden: h,
  fullWidth: d,
  label: i,
  className: u,
  checked: n,
  disabled: s,
  containerClass: b,
  labelClass: f,
  iconClass: k,
  error: x,
  errorMessage: r,
  notice: _,
  viewStyle: l = "circle",
  size: p = "small",
  ...N
}, C) => /* @__PURE__ */ m("div", { className: o(
  c.container,
  b,
  d && c.fullWidth,
  h && c.hidden,
  s && c.disabled
), children: [
  /* @__PURE__ */ m("label", { className: c.inputContainer, htmlFor: a, children: [
    /* @__PURE__ */ e(
      "input",
      {
        ...N,
        disabled: s,
        type: "checkbox",
        id: a,
        name: a,
        className: o(c.checkbox, u),
        onChange: t,
        checked: n,
        ref: C
      }
    ),
    /* @__PURE__ */ e("span", { className: o(
      c.icon,
      k,
      n ? c.checked : c.unchecked,
      c[l],
      c[p]
    ), children: (l === "circle" || n) && /* @__PURE__ */ e(j, {}) }),
    i && /* @__PURE__ */ e("span", { className: o(c.label, f), children: i })
  ] }),
  x && r && /* @__PURE__ */ e("span", { className: c.errorText, children: r }),
  _ && /* @__PURE__ */ e("span", { className: c.notice, children: _ })
] }));
export {
  P as default
};
